<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="100%">
    <path
        :style="`fill: ${primaryColor}`"
        d="M 43.90625 1.96875 C 43.863281 1.976563 43.820313 1.988281 43.78125 2 L 40 2 C 39.730469 2 39.46875 2.121094 39.28125 2.3125 L 25.21875 16.59375 L 26.4375 18.15625 L 30.21875 14.34375 L 30.90625 20.875 L 29.8125 22.5 L 30.9375 23.96875 C 30.988281 24.035156 31.046875 24.089844 31.09375 24.15625 L 43 6.3125 L 43 28.28125 C 42.402344 28.628906 42 29.261719 42 30 C 42 30.738281 42.402344 31.371094 43 31.71875 L 43 32.96875 C 43 33.90625 43.609375 34.789063 44.5625 35.0625 C 45.503906 35.332031 46.164063 36.265625 45.96875 37.375 C 45.832031 38.148438 45.152344 38.832031 44.375 38.96875 C 43.0625 39.199219 42 38.238281 42 37 C 42.003906 36.640625 41.816406 36.304688 41.503906 36.121094 C 41.191406 35.941406 40.808594 35.941406 40.496094 36.121094 C 40.183594 36.304688 39.996094 36.640625 40 37 C 40 39.433594 42.238281 41.371094 44.71875 40.9375 C 46.355469 40.648438 47.652344 39.355469 47.9375 37.71875 C 48.304688 35.625 46.992188 33.695313 45.09375 33.15625 C 45.054688 33.144531 45 33.0625 45 32.96875 L 45 31.71875 C 45.597656 31.371094 46 30.738281 46 30 C 46 29.261719 45.597656 28.628906 45 28.28125 L 45 3.0625 C 45.003906 3.015625 45.003906 2.953125 45 2.90625 C 44.992188 2.863281 44.980469 2.820313 44.96875 2.78125 C 44.949219 2.695313 44.917969 2.609375 44.875 2.53125 C 44.832031 2.453125 44.78125 2.378906 44.71875 2.3125 C 44.691406 2.277344 44.660156 2.246094 44.625 2.21875 C 44.550781 2.15625 44.464844 2.101563 44.375 2.0625 C 44.34375 2.050781 44.316406 2.039063 44.28125 2.03125 C 44.160156 1.988281 44.035156 1.964844 43.90625 1.96875 Z "/>
    <path
        :style="`fill: ${secondaryColor}`"
        d="M 40.40625 4 L 42.125 4 L 38.71875 9.125 L 38.4375 5.96875 Z "/>
    <path
        :style="`fill: ${secondaryColor}`"
        d="M 36.59375 7.875 L 36.84375 10.9375 L 33.34375 11.15625 Z "/>
    <path
        :style="`fill: ${secondaryColor}`"
        d="M 36.15625 12.96875 L 32.625 18.25 L 32.09375 13.25 Z "/>
    <path
        :style="`fill: ${primaryColor}`"
        d="M 8 16 C 6.347656 16 5 17.347656 5 19 L 5 31 C 5 32.652344 6.347656 34 8 34 L 11 34 L 11 36 L 8 36 C 4.691406 36 2 38.691406 2 42 C 2 45.308594 4.691406 48 8 48 L 30 48 C 33.308594 48 36 45.308594 36 42 C 36 38.691406 33.308594 36 30 36 L 27 36 L 27 34 L 28 34 C 29.652344 34 31 32.652344 31 31 L 31 27 C 30.992188 26.125 30.691406 25.253906 30.15625 24.5625 L 24.40625 17.15625 C 23.839844 16.433594 22.949219 16 22.03125 16 Z "/>
    <path
        :style="`fill: ${secondaryColor}`"
        d="M 18.3125 18 L 22.03125 18 C 22.339844 18 22.625 18.132813 22.8125 18.375 L 28.59375 25.8125 C 28.859375 26.152344 28.992188 26.566406 29 27 L 20.75 27 Z "/>
    <path
        :style="`fill: ${secondaryColor}`"
        d="M 13 34 L 25 34 L 25 36 L 13 36 Z "/>
    <path
        :style="`fill: ${secondaryColor}`"
        d="M 8 40 C 9.105469 40 10 40.894531 10 42 C 10 43.105469 9.105469 44 8 44 C 6.894531 44 6 43.105469 6 42 C 6 40.894531 6.894531 40 8 40 Z "/>
    <path
        :style="`fill: ${secondaryColor}`"
        d="M 14 40 C 15.105469 40 16 40.894531 16 42 C 16 43.105469 15.105469 44 14 44 C 12.894531 44 12 43.105469 12 42 C 12 40.894531 12.894531 40 14 40 Z "/>
    <path
        :style="`fill: ${secondaryColor}`"
        d="M 24 40 C 25.105469 40 26 40.894531 26 42 C 26 43.105469 25.105469 44 24 44 C 22.894531 44 22 43.105469 22 42 C 22 40.894531 22.894531 40 24 40 Z "/>
    <path
        :style="`fill: ${secondaryColor}`"
        d="M 30 40 C 31.105469 40 32 40.894531 32 42 C 32 43.105469 31.105469 44 30 44 C 28.894531 44 28 43.105469 28 42 C 28 40.894531 28.894531 40 30 40 Z"/>
  </svg>
</template>
<script>
import Vue from "vue";

export default {
  data: () => ({
  }),
  computed: {
    primaryColor() {
      const primaryColor = Vue.prototype.$vuetify.theme.themes.light.primary
      return primaryColor || '#0b333b'
    },
    secondaryColor() {
      const secondaryColor = Vue.prototype.$vuetify.theme.themes.light.warning
      return secondaryColor || '#d7b039'
    },
  },
}
</script>